module.exports = __webpack_public_path__ + "img/message-praise.665bf659.png";